export default __webpack_public_path__ + "static/media/TO.8ca58268.svg";